<template>
  <div class="card-tool">
    <router-link v-if="url" :to="url"></router-link>

    <div class="card-tool__image">
      <img
        :src="tool && tool.image && tool.image.largeSizeUrl ? tool.image.largeSizeUrl : ''"
        alt="tool image"
      />
    </div>

    <h3 class="card-tool__title">{{ tool.title }}</h3>
    <p class="text-gray-700">{{ tool.subTitle }}</p>
    <h6 class="text-black-700 tools_card-comment">
      {{ tool.comment }}
    </h6>
  </div>
</template>

<script>
export default {
  name: 'ToolsCard',
  props: {
    type: String,
    tool: {
      type: Object,
      required: true
    }
  },
  computed: {
    url() {
      if (this.$route.path.includes('/client')) {
        return '/client/startups/' + this.$route.params.company + '/deals/' + this.tool.key;
      }

      return this.tool.url;
    }
  }
};
</script>

<style lang="scss" scoped>
.tools_card-comment {
  margin-top: 0.7rem;
}
.card-tool {
  position: relative;

  > a {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }

  &__image {
    padding-top: 73%;
    line-height: 0;
    position: relative;
    width: 100%;
    height: 100%;
    // max-height: 270px;
    // max-width: 370px;
    overflow: hidden;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      /* IE10+ CSS styles go here */
      overflow: hidden;
    }

    img {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      height: 100%;
      display: block;
      width: 100%;
      object-fit: cover;

      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /* IE10+ CSS styles go here */
        top: 50%;
        left: 50%;
        height: auto;
        width: auto;
        min-height: 100%;
        min-width: 100%;
        transform: translate3d(-50%, -50%, 0);
      }
    }
  }

  &__title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-top: 1.6rem;
    font-size: 1.15rem;
  }

  p {
    height: 48px;
    line-height: 1.5;
    text-overflow: ellipsis;
    padding-right: 2rem;
    padding-top: 0.5rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    font-size: 0.9rem;
    -webkit-box-orient: vertical;
  }
}
</style>
